import React from 'react';
import {Phone, Mail, Clock} from 'lucide-react';

export default function ContactBar() {
  return (
    <div className="bg-blue-900 text-white py-2 px-4">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-4 text-sm">
        <div className="flex items-center gap-6 flex-wrap">
          <a href="tel:9842309599" className="flex items-center gap-2 hover:text-teal-300 transition-colors">
            <Phone className="w-4 h-4" aria-hidden="true" />
            <span>(984) 230-9599</span>
          </a>
          <a href="mailto:info@EmergeNCDiagnostics.com" className="flex items-center gap-2 hover:text-teal-300 transition-colors">
            <Mail className="w-4 h-4" aria-hidden="true" />
            <span>info@EmergeNCDiagnostics.com</span>
          </a>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4" aria-hidden="true" />
          <span>Mon-Fri: 8AM-5PM | Sat-Sun: 8AM-2PM</span>
        </div>
      </div>
    </div>
  );
}
